<div
  class="flex flex-col rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden h-80 w-72 mt-2"
  >
  <div class="p-4 pb-2 flex flex-col">
    <div>
      <div class="relative rounded-md shadow-sm">
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <ng-icon name="heroMagnifyingGlass" class="h-4 w-4 text-gray-400" size="20px"></ng-icon>
        </div>
        <input
          type="filter"
          name="filter"
          id="filter"
          [ngModel]="filterValue | async"
          (ngModelChange)="filter($event)"
          class="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
          [placeholder]="({ key: 'filter' } | i18n) + '...'"
          />
      </div>
    </div>
    <div class="flex flex-row justify-between text-xs mt-2 cursor-default">
      <button (click)="toggleSort()" class="flex flex-row justify-center items-center text-primary-600 hover:text-primary-700">
        <span>{{ { key: 'sort', n: 1 } | i18n }}</span>
        <ng-icon name="heroArrowsUpDown" class="h-4 w-4 ml-0.5" size="12px"></ng-icon>
      </button>
      @if (algolia.observeAttributeFilterCount(this.facet) | async) {
        <button
          (click)="clear()"
          class="flex flex-row justify-center items-center text-primary-600 hover:text-primary-700"
          >
          <span>{{ { key: 'reset', n: 1 } | i18n }}</span>
          <ng-icon name="heroXMark" class="h-4 w-4 ml-0.5" size="12px"></ng-icon>
        </button>
      }
    </div>
  </div>

  <form class="space-y-4 pl-4 pb-4 pt-2 overflow-y-auto">
    @for (value of filteredItems | async; track value) {
      <div class="flex items-center">
        <input
          [id]="this.facet + '-' + value._id"
          type="checkbox"
          class="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
          (change)="algolia.toggleAttributeFilter(this.facet, value._id)"
          [checked]="algolia.observeIsAttributeFilterActive(this.facet, value._id) | async"
          />
        <label
          [for]="this.facet + '-' + value._id"
          class="ml-3 whitespace-nowrap text-sm font-medium text-gray-900 flex flex-row justify-between w-full overflow-hidden text-ellipsis"
          ><span class="overflow-hidden text-ellipsis">{{ value.designation | i18n }}</span>
          <span class="bg-gray-100 text-gray-400 text-xs font-medium me-2 px-2.5 py-0.5 rounded-full ml-4">{{ value.count }}</span></label
          >
        </div>
      }
    </form>
  </div>
